(() => {
  const money = n => '$' + (Math.round(n * 100) / 100).toFixed(2);
  const parseMoney = s => Number(String(s || '').replace(/[^0-9.]/g, '')) || 0;
  const root = () => (window.Shopify?.routes?.root || '/');
  const refreshBagCount = async () => {
    try {
      const cart = await (await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      document.querySelectorAll('.bag > span:not(.sr-only)').forEach(el => { el.textContent = '(' + cart.item_count + ')'; });
    } catch {}
  };
  function init(scope = document) {
    const form = scope.querySelector('#ProductForm');
    if (form && !form.dataset.upgradeBound) {
      form.dataset.upgradeBound = 'true';
      const select = form.querySelector('[name="id"]');
      const quantity = form.querySelector('[name="quantity"]');
      const priceEl = document.getElementById('ProductPrice');
      const saveEl = document.querySelector('[data-price-save]');
      const planInput = form.querySelector('[data-plan-input]');
      const typeBox = form.querySelector('[data-purchase-type]');
      let plans = {};
      try { plans = JSON.parse(form.querySelector('[data-plan-prices]')?.textContent || '{}'); } catch {}
      const choices = [...document.querySelectorAll('.supply-options--compact [data-supply-choice]')];
      const baseUnit = () => {
        const one = choices.find(c => c.dataset.supplyChoice === '1');
        return one ? parseMoney(one.dataset.totalPrice) : parseMoney(select?.selectedOptions[0]?.dataset.price);
      };
      const currentOnce = () => {
        const active = choices.find(c => c.getAttribute('aria-pressed') === 'true');
        if (active) return parseMoney(active.dataset.totalPrice);
        return parseMoney(select?.selectedOptions[0]?.dataset.price) * Number(quantity?.value || 1);
      };
      const bottles = () => {
        const active = choices.find(c => c.getAttribute('aria-pressed') === 'true');
        return active ? Number(active.dataset.supplyChoice) : Number(quantity?.value || 1);
      };
      const subChecked = () => typeBox && typeBox.querySelector('[name="purchase_type"]:checked')?.value;
      const render = () => {
        const once = currentOnce();
        const n = bottles();
        const unit = baseUnit();
        const plan = plans[select?.value];
        let shown = once;
        if (typeBox) {
          const onceEl = typeBox.querySelector('[data-once-price]');
          const subEl = typeBox.querySelector('[data-sub-price]');
          const subTotal = plan ? (plan.sub / 100) * Number(quantity?.value || 1) : once * 0.85;
          if (onceEl) onceEl.textContent = money(once);
          if (subEl) subEl.textContent = money(subTotal);
          const planId = subChecked();
          if (planId) {
            shown = subTotal;
            if (planInput) { planInput.value = plan?.plan || planId; planInput.disabled = false; }
          } else if (planInput) { planInput.value = ''; planInput.disabled = true; }
        }
        if (priceEl) priceEl.textContent = money(shown);
        if (saveEl) {
          const full = unit * n;
          const saved = full - shown;
          if (saved > 0.5) { saveEl.hidden = false; saveEl.innerHTML = '<s>' + money(full) + '</s> You save ' + money(saved) + ' (' + Math.round(saved / full * 100) + '%)'; }
          else saveEl.hidden = true;
        }
        const compareSingle = Number(document.querySelector('[data-compare-single]')?.dataset.compareSingle || 0) / 100;
const compareEl = document.querySelector('[data-price-compare]');
if (compareEl) { const showCmp = n === 1 && compareSingle > shown + 0.5; compareEl.hidden = !showCmp; if (showCmp) compareEl.textContent = money(compareSingle); }
const stickyPrice = document.querySelector('[data-sticky-price]');
if (stickyPrice) stickyPrice.textContent = money(shown);
const stickyCompare = document.querySelector('[data-sticky-compare]');
if (stickyCompare) { const cmp = n === 1 ? compareSingle : unit * n; const showS = cmp > shown + 0.5; stickyCompare.hidden = !showS; if (showS) stickyCompare.textContent = money(cmp); }
      };
      const later = () => setTimeout(render, 0);
      select?.addEventListener('change', later);
      quantity?.addEventListener('change', later);
      quantity?.addEventListener('input', later);
      choices.forEach(c => c.addEventListener('click', later));
      typeBox?.addEventListener('change', render);
      later();
      const sticky = document.querySelector('[data-sticky-atc]');
const button = form.querySelector('.add-to-bag');
const stickyMobile = window.matchMedia ? window.matchMedia('(max-width: 999px)') : null;
if (sticky && button) {
const showSticky = show => { sticky.hidden = !show; sticky.setAttribute('aria-hidden', String(!show)); };
let desktopShow = false;
const sync = () => { if (stickyMobile && stickyMobile.matches) showSticky(true); else showSticky(desktopShow); };
if ('IntersectionObserver' in window) {
const io = new IntersectionObserver(entries => {
const e = entries[0];
desktopShow = !e.isIntersecting && e.boundingClientRect.top < 0;
sync();
}, { threshold: 0 });
io.observe(button);
} else { desktopShow = true; }
sync();
if (stickyMobile) { if (stickyMobile.addEventListener) stickyMobile.addEventListener('change', sync); else if (stickyMobile.addListener) stickyMobile.addListener(sync); }
}
    }
    scope.querySelectorAll('[data-pairs-add]').forEach(btn => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        const original = btn.textContent;
        btn.textContent = 'Adding…';
        try {
          const res = await fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(btn.dataset.pairsAdd), quantity: 1 }) });
          if (!res.ok) throw new Error('add failed');
          btn.textContent = btn.dataset.addedLabel || 'Added';
          btn.classList.add('is-added');
          refreshBagCount();
          if (/\/cart\/?$/.test(location.pathname)) location.reload();
          else if (window.PotencyCart) window.PotencyCart.open();
        } catch {
          btn.textContent = original;
          btn.disabled = false;
        }
      });
    });

    scope.querySelectorAll('[data-select-supply]').forEach(btn => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', () => {
        const n = btn.dataset.selectSupply;
        const choice = document.querySelector('.supply-options--compact [data-supply-choice="' + n + '"]');
        if (choice) choice.click();
        else { const q = document.querySelector('#ProductForm [name="quantity"]'); if (q) { q.value = n; q.dispatchEvent(new Event('change', { bubbles: true })); } }
        document.getElementById('ProductForm')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    const gal = scope.querySelector('[data-rich-gallery]');
    if (gal && !gal.dataset.dotsTrimmed) {
      gal.dataset.dotsTrimmed = 'true';
      const n = gal.querySelectorAll('[data-gallery-panel]').length;
      gal.querySelectorAll('.gallery-dots button').forEach((d, i) => { if (i >= n) d.hidden = true; });
      const st = gal.querySelector('[data-gallery-status]'); if (st) st.textContent = '1 / ' + n;
    }

    const animEls = scope.querySelectorAll('[data-anim]');
    if (animEls.length) {
      if ('IntersectionObserver' in window) {
        const aio = new IntersectionObserver(entries => {
          entries.forEach(e => { if (e.isIntersecting && e.intersectionRatio >= 0.25) { e.target.classList.add('is-in'); aio.unobserve(e.target); } });
        }, { threshold: [0, 0.25, 0.5] });
        animEls.forEach(el => { if (el.dataset.aio) return; el.dataset.aio = 'true'; aio.observe(el); });
      } else { animEls.forEach(el => el.classList.add('is-in')); }
    }
    const sciVideos = scope.querySelectorAll('.science-video');
    if (sciVideos.length && 'IntersectionObserver' in window) {
      const vio = new IntersectionObserver(entries => {
        entries.forEach(e => {
          const v = e.target;
          if (e.isIntersecting && e.intersectionRatio >= 0.5) {
            if (!v.dataset.started) { v.dataset.started = 'true'; try { v.currentTime = 0; } catch {} }
            v.muted = true; v.play().catch(() => {});
          } else if (!v.paused) { v.pause(); }
        });
      }, { threshold: [0, 0.5, 1] });
      sciVideos.forEach(v => { if (v.dataset.vio) return; v.dataset.vio = 'true'; v.removeAttribute('autoplay'); v.pause(); vio.observe(v); });
    }
    const bar = scope.querySelector('[data-shipping-bar]');
    if (bar && !bar.dataset.bound) {
      bar.dataset.bound = 'true';
      const threshold = Number(bar.dataset.threshold || 30);
      const subtotal = Number(bar.dataset.subtotal || 0) / 100;
      const fill = bar.querySelector('[data-shipping-fill]');
      const label = bar.querySelector('[data-shipping-label]');
      const pct = Math.min(100, Math.round(subtotal / threshold * 100));
      if (fill) fill.style.width = pct + '%';
      if (label) label.textContent = subtotal >= threshold ? 'You’ve unlocked free US shipping.' : 'Add ' + money(threshold - subtotal) + ' more for free US shipping.';
    }
  }

  // Subscription upsell interstitial: shown when a one-time purchase is submitted while a Subscribe & save option exists.
  function upsellDialog() {
    let d = document.getElementById('SubUpsell');
    if (d) return d;
    d = document.createElement('dialog');
    d.id = 'SubUpsell'; d.className = 'sub-upsell';
    d.innerHTML = '<form method="dialog" class="sub-upsell-card"><button type="button" class="sub-upsell-close" data-upsell-close aria-label="Close">&times;</button><p class="eyebrow">Wait a second</p><h2>Are you sure you want to pay the original price instead of subscribing with <span class="sub-upsell-big">15% OFF?</span></h2><p class="sub-upsell-sub">Delivered every 30 days. Skip, pause or cancel anytime.</p><button type="button" class="button sub-upsell-yes" data-upsell-sub>No, I\'ll take 15% off</button><button type="button" class="sub-upsell-no" data-upsell-once>Yes, I don\'t care about the 15% off, I\'ll pay the full price.</button></form>';
    document.body.appendChild(d);
    return d;
  }
  function upsellIntercept(event, trigger) {
    const form = document.getElementById('ProductForm');
    if (!form) return;
    if (form.dataset.upsellDone === '1') return;
    const typeBox = form.querySelector('[data-purchase-type]');
    const subRadio = typeBox && typeBox.querySelector('[name="purchase_type"]:not([value=""])');
    const checked = typeBox && typeBox.querySelector('[name="purchase_type"]:checked');
    if (!subRadio || subRadio.disabled || !checked || checked.value) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const d = upsellDialog();
    const go = () => { form.dataset.upsellDone = '1'; setTimeout(() => { delete form.dataset.upsellDone; }, 1500); trigger(); };
    d.querySelector('[data-upsell-sub]').onclick = () => { d.close(); subRadio.checked = true; subRadio.dispatchEvent(new Event('change', { bubbles: true })); setTimeout(go, 80); };
    d.querySelector('[data-upsell-once]').onclick = () => { d.close(); go(); };
    d.querySelector('[data-upsell-close]').onclick = () => d.close();
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
  }
  document.addEventListener('click', event => {
    const btn = event.target.closest && event.target.closest('#ProductForm .add-to-bag, [data-sticky-add]');
    if (!btn) return;
    upsellIntercept(event, () => btn.click());
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target.closest ? event.target.closest('#ProductForm') : null;
    if (!form) return;
    upsellIntercept(event, () => { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
  }, true);
  // Bundle subscription: Shopify fixed bundles cannot carry a selling plan, so a subscribed bundle adds each formula with the bundle's own plan (priced to 15% off the bundle).
  document.addEventListener('submit', event => {
    const form = event.target.closest ? event.target.closest('#ProductForm') : null;
    if (!form) return;
    const data = form.querySelector('[data-bundle-sub]');
    if (!data) return;
    const checked = form.querySelector('[name="purchase_type"]:checked');
    if (!checked || !checked.value) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (form.dataset.submitting === 'true') return;
    let items = [];
    try { items = JSON.parse(data.textContent || '[]'); } catch {}
    if (!items.length) return;
    form.dataset.submitting = 'true';
    const button = form.querySelector('.add-to-bag');
    const status = form.querySelector('.form-feedback');
    const label = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    if (status) status.textContent = '';
    fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
      .then(async r => { const res = await r.json(); if (!r.ok) throw new Error(res.description || 'Unable to add this bundle. Please try again.'); return res; })
      .then(() => { refreshBagCount(); if (window.PotencyCart) { if (status) status.textContent = 'Added to your bag as a subscription.'; window.PotencyCart.open(); } else { if (status) status.textContent = 'Added to your bag as a subscription. Opening your bag…'; setTimeout(() => { location.href = root() + 'cart'; }, 500); } })
      .catch(err => { if (status) status.textContent = err.message; })
      .finally(() => { form.dataset.submitting = 'false'; if (button) { button.disabled = false; button.textContent = label; } });
  }, true);
  document.addEventListener('shopify:section:load', e => init(e.target));
  init();
})();
